<script>
import { mapActions } from 'vuex';
import BaseAutocompleteSearchRequestFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter';

export default {
  name: 'FilesFilter',

  extends: BaseAutocompleteSearchRequestFilter,

  methods: {
    ...mapActions('documents_lists', ['getFilteredFiles']),
    getData() {
      return this.getFilteredFiles({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
